<div style="width: 290px; padding: 5px;">
  <div class="row" style="margin: 0">
    <div class="col-md-12 form-group" style="padding: 0;">
      <app-select
        #multilookupFilter
        [multiple]="true"
        [(ngModel)]="selectedItems"
        [items]="items"
        [selected]="onSelect"
        [removed]="onSelect"
        [allowClear]="true"
        [placeholder]="placeholderText"
        [appendTo]="'body'"
      ></app-select>
    </div>
  </div>
</div>
